import React, { Fragment, useCallback, useContext, useState, useEffect } from 'react';
import { CreatedByMe, Favourites, MyBookmark, Newsletter, Notification, NoBookmarksFound } from '../../../Constant';
import BookmarkContext from '../../../_helper/Bookmark';
import DataLoop from './DataLoop';
import FavDataLoop from './FavDataLoop';
import SharedWithMee from './ShareWithMe';
import EditBookmarkModal from './EditBookmark';
import GridClass from './Common/GridClass';
import PromoCodeDataLoop from './PromoCodeDataLoop';
import { Row, Card, CardBody, TabContent, TabPane, Table } from 'reactstrap';
import ManagePromoCode from '../../../api/ManagePromoCode';
import { toast } from 'react-toastify';

const BookmarksTabs = () => {
  const { activeTabss } = useContext(BookmarkContext);
  const [gridView, setgridView] = useState(true);
  const [promoCodes, setPromoCodes] = useState([]);
  const [loading, setLoading] = useState(false);

  const callback = useCallback((grid) => {
    return setgridView(grid);
  });

  const loadPromoCodes = () => {
    setLoading(true);
    ManagePromoCode.loadPromoCodes()
      .then(response => {
        console.log("Promo Codes:", response.data);
        setPromoCodes(response.data.data || []);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error loading promo codes:", error);
        toast.error("Erreur lors du chargement des codes promo. Réessayer plus tard.");
        setLoading(false);
      });
  };

  useEffect(() => {
    loadPromoCodes();
  }, []);

  return (
    <Fragment>
      <TabContent activeTab={activeTabss}>
        <TabPane tabId='1'>
          <Card className='mb-0'>
            <GridClass title='Codes Promo' callback={callback} />
            <CardBody className='pb-0'>
              {loading ? (
                <div className='text-center'>
                  <p>Chargement...</p>
                </div>
              ) : (
                <div className={`details-bookmark text-center ${gridView ? '' : 'list-bookmark'}`}>
                  <PromoCodeDataLoop promoCodes={promoCodes} reloadPromoCodes={loadPromoCodes} />
                </div>
              )}
            </CardBody>
          </Card>
        </TabPane>
        <EditBookmarkModal />
      </TabContent>
    </Fragment>
  );
};
export default BookmarksTabs;
